import React from 'react';
import ProjectTransitionFields from './ProjectTransitionFields';
import { projectTransitionSchema } from '../../../lib/project-transition-schemas';

export default function LiveForm({ values, onChange, errors }) {
  return <ProjectTransitionFields schema={projectTransitionSchema('live')} values={values} onChange={onChange} errors={errors} />;
}
